export default function AboutSection() {
  const quoteBg =
    "https://readdy.ai/api/search-image?query=Warm%20watermelon%20and%20cream%20abstract%20editorial%20backdrop%20with%20soft%20red%20melon%20slices%20and%20green%20rind%20accents%2C%20bright%20airy%20minimal%20art%2C%20no%20text&width=1400&height=700&seq=about-cta-1&orientation=landscape";

  return (
    <section className="w-full">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6 py-16 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-4 py-1.5 text-xs font-semibold text-primary-700">
              <i className="ri-heart-line"></i> 关于今日看瓜
            </span>
            <h2 className="font-heading mt-5 text-3xl md:text-4xl font-bold text-foreground-950 leading-snug">
              我们替你把瓜<em className="not-italic text-primary-600">理清楚</em>
            </h2>
            <p className="mt-5 text-base text-foreground-600 leading-relaxed">
              信息越碎，越需要一个把来龙去脉讲清楚的地方。今日看瓜坚持做三件事：聚合公开信息、按时间线梳理、标注事实与讨论的边界。
            </p>
            <ul className="mt-6 space-y-3">
              {[
                { i: "ri-checkbox-circle-line", t: "信息可溯源，不编造事实", d: "只整理已公开的声明、报道与表态，并注明节点。" },
                { i: "ri-timer-flash-line", t: "紧跟热点，按小时跟进", d: "热门事件关键节点动态补充，脉络实时完整。" },
                { i: "ri-scales-3-line", t: "区分事实与观点", d: "标注“已确认”与“网友讨论”，把判断留给你。" },
              ].map((f) => (
                <li key={f.t} className="flex gap-3">
                  <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                    <i className={`${f.i} text-base`}></i>
                  </span>
                  <div>
                    <p className="font-medium text-foreground-950 text-[15px]">{f.t}</p>
                    <p className="text-sm text-foreground-600">{f.d}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
            {[
              { v: "96.8%", l: "用户表示更省力就看懂了来龙去脉" },
              { v: "24h", l: "热门事件平均跟进响应时间" },
              { v: "4+", l: "圈层栏目，覆盖娱乐到科技文化" },
              { v: "50+", l: "编辑与信息整理团队共同把关" },
            ].map((s) => (
              <div key={s.l} className="rounded-2xl border border-background-200 bg-background-50 p-6">
                <p className="font-display text-4xl font-bold text-primary-600">{s.v}</p>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{s.l}</p>
              </div>
            ))}
            <div className="sm:col-span-2 rounded-2xl overflow-hidden relative h-44">
              <img src={quoteBg} alt="今日看瓜关于我们板块装饰背景" className="absolute inset-0 h-full w-full object-cover object-center" />
              <div className="absolute inset-0 bg-gradient-to-r from-primary-500/95 to-primary-600/85"></div>
              <div className="relative flex h-full flex-col justify-center p-7">
                <p className="font-heading text-lg font-bold text-background-50 leading-relaxed">
                  “把复杂的事讲简单，把碎片的信息串完整。”
                </p>
                <p className="mt-2 text-sm text-background-100/90">—— 今日看瓜内容原则</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}